export default "__VITE_ASSET__C0Z$_v_m__"